import * as req from 'api/actions';
import moment from 'moment';
import * as c from './constants';

export const getBillsList = (payload = {}, callback) =>
  req.list(
    c.BILLS_LIST,
    'api/v1/administrators/bills_payments',
    payload,
    callback
  );

export const getCounts = (payload = {}, callback) =>
  req.item(
    c.GET_COUNTS,
    '/api/v1/administrators/e_bills/statistics',
    callback,
    payload
  );

export const getCollections = (payload = {}, callback) =>
  req.item(
    c.GET_COLLECTION,
    // replace API for payment support later
    'api/v1/administrators/dashboard/collection_graph',
    callback,
    payload
  );

export const getYearList = (
  payload,
  callback
) =>
  req.list(
    c.GET_YEAR_LIST,
    // replace API for payment support later
    'api/v1/administrators/dashboard/collection_graph_year',
    payload,
    callback
  );

// BILLS PAYMENT CHART (AREA CHART)
export const getTotalStats = (payload, callback) =>
  req.item(
    c.GET_TOTAL_STATS,
    'api/v1/administrators/e_bills/statistics',
    payload,
    callback
  );

export const getGraphStats = (
  payload = {
    period: 'MONTHLY',
    date_from: moment().startOf('year').format('YYYY-MM-DD'),
    date_to: moment().endOf('year').format('YYYY-MM-DD'),
  },
  callback
) =>
  req.list(
    c.GET_GRAPH_STATS,
    'api/v1/administrators/e_bills/graph',
    payload,
    callback
  );
